import { ParsedUrlQuery } from 'querystring';

export function getIsAuction(query: ParsedUrlQuery, pathname: string) {
    if (query['is_auction']) {
        return query['is_auction'];
    }

    if (pathname.includes('/new-homes/')) {
        return 'false';
    }

    return '';
}
